/**
 * Error thrown when an operation targets a record that is not present in the data store.
 * Distinguishes an expected "no row" outcome (which callers may choose to recover from,
 * for example by inserting) from real storage failures that warrant error telemetry.
 */
export class RecordNotFoundError extends Error {
	/**
	 * @constructor
	 * @param message Human-readable description of which record was missing and from where.
	 */
	constructor(message: string) {
		super(message);
		this.name = 'RecordNotFoundError';
		// Restore the prototype chain when targeting ES5 (TS compilation target downlevels Error).
		Object.setPrototypeOf(this, RecordNotFoundError.prototype);
	}
}
